import { Locale } from '../constants';

export default {
  locale: {
    set: (locale: string): void => {
      if (Object.values(Locale).includes(locale)) {
        document.cookie = `NEXT_LOCALE=${locale}; max-age=${60 * 60 * 24 * 365}; path=/`;
      }
    },
  },
  affiliate_id: {
    set: (affiliateId: string): void => {
      const maxAge = 60 * 60 * 24 * 365; // 1 year, in seconds
      document.cookie = `affiliate_id=${affiliateId}; max-age=${maxAge}; path=/`;
    },
    get: (): string | undefined => {
      const cookie = document.cookie.split('; ').find((row) => row.startsWith('affiliate_id='));
      return cookie?.split('=')[1];
    },
    remove: (): void => {
      document.cookie = 'affiliate_id=; max-age=0; path=/';
    },
  },
  device_id: {
    set: (deviceId: string): void => {
      const maxAge = 60 * 60 * 24 * 365; // 1 year, in seconds
      document.cookie = `tabist-id=${deviceId}; max-age=${maxAge}; path=/`;
    },
    get: (): string | undefined => {
      const cookie = document.cookie.split('; ').find((row) => row.startsWith('tabist-id='));
      return cookie?.split('=')[1];
    },
  },
};
